/*
 * @Description:
 * @Date: 2023/4/19 上午11:43:11
 */
export const route = [
  {
    path: '/main/form-add-list',
    name: 'form-add-list',
    meta: {
      title: '表单管理',
      isMenuSkip: true
    },
    component: () => import('../views/form-add-list.vue')
  }
];
